function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { jsx as _jsx } from "react/jsx-runtime";
const renderBold = (text, children) => {
  return text.bold ? /*#__PURE__*/_jsx("strong", {
    children: children
  }) : children;
};
const renderItalic = (text, children) => {
  return text.italic ? /*#__PURE__*/_jsx("em", {
    children: children
  }) : children;
};
const renderUnderline = (text, children) => {
  return text.underline ? /*#__PURE__*/_jsx("u", {
    children: children
  }) : children;
};
const renderStrikethrough = (text, children) => {
  return text.strikethrough ? /*#__PURE__*/_jsx("s", {
    children: children
  }) : children;
};
export const Leaf = _ref => {
  let {
    attributes,
    leaf,
    children
  } = _ref;
  const elementToRender = renderStrikethrough(leaf, renderUnderline(leaf, renderItalic(leaf, renderBold(leaf, children))));
  return /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({}, attributes), {}, {
    children: elementToRender
  }));
};